export const GRID_CONFIG = {
    mobile: {
        fieldsContainer: {
            cols: [
              {
                width: "repeat(1, 1fr)",
              },
            ],
        },
        fieldsItem: {
            divider: 1,
        },
    },
    tablet: {
        fieldsContainer: {
            cols: [
              {
                width: "repeat(2, 1fr)",
              },
            ],
        },
        fieldsItem: {
            divider: 2,
        },
    },
    smalldesktop: {
      fieldsContainer: {
          cols: [
            {
              width: "repeat(3, 1fr)",
            },
          ],
      },
      fieldsItem: {
          divider: 3,
      },
  },
  desktop: {
        fieldsContainer: {
            cols: [
              {
                width: "repeat(4, 1fr)",
              },
            ],
        },
        fieldsItem: {
            divider: 4,
        },
    },
};    